<template>
  <v-app>
    <v-container class="pa-0 fill-height">
      <v-row class="fill-height justify-center ma-0">
        <v-col class="col-12 col-md-11">
          <h2>Próximas Consultas</h2>
          <v-container grid-list-lg class="pa-0">
            <div class="d-flex justify-center align-center flex-column" v-if="isLoading">
              <p>Carregando...</p>
              <v-progress-circular indeterminate color="primary" class="mb-0"></v-progress-circular>
            </div>
            <v-row v-if="!isLoading">
              <v-col
                class="col-12 col-md-4 mt-md-4"
                v-for="(item, index) in consultation"
                :key="index"
              >
                <v-divider></v-divider>
                <router-link
                  tag="div"
                  style="cursor: pointer;"
                  class="my-list"
                  :to="{name: 'DetalheConsulta', params: {id: item.id}}"
                >
                  <p class="ma-0">{{item.patient.name}}</p>
                  <span class="date ma-2 align-end d-flex">
                    <v-icon color="primary">date_range</v-icon>
                    <p class="mb-0 ml-2">{{moment(item.date).format("DD/MM")}}</p>
                  </span>
                  <span class="time ma-2 align-end d-flex">
                    <v-icon color="primary">access_time</v-icon>
                    <p class="mb-0 ml-2">{{item.time | formatDateTZ(item.date)}}</p>
                  </span>
                </router-link>
              </v-col>
            </v-row>
            <v-row class="fill-height justify-center" v-if="!isConsultation && !isLoading">
              <v-col class="col-10 col-md-6">
                <div class="no-schedule pa-3">
                  <v-icon
                    x-large
                    color="gray"
                    style="font-size: 80px; padding-bottom:10px"
                  >sentiment_very_dissatisfied</v-icon>
                  <p
                    class="subtitle-1"
                    style="color: #6F6F6F; font-weight: bold"
                  >Você não tem compromissos futuros.</p>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-col>

        <v-col class="col-12 col-md-11">
          <div class="mt-4">
            <v-container grid-list-lg class="pa-0">
              <v-row class="justify-center">
                <v-col class="col-10 col-sm-6 col-md-3 col-lg-3">
                  <CardInfo
                    sessionName="Agenda"
                    iconName="event"
                    :info="qtd_consultation_now"
                    link="Schedule"
                    colorIcon="primary"
                  />
                </v-col>

                <!-- <v-col class="col-10 col-sm-6 col-md-3 col-lg-3">
                  <CardInfo sessionName="Pacientes" iconName="people" :info="total_patients" link="historico-pacientes" colorIcon="primary" />
                </v-col>-->
                <v-col class="col-10 col-sm-6 col-md-3 col-lg-3">
                  <CardInfo
                    sessionName="Pacientes"
                    imgName="speaking_90x90_red"
                    :info="total_patients"
                    link="historico-pacientes"
                    colorIcon="primary"
                  />
                </v-col>

                <!-- <v-col class="col-10 col-sm-6 col-md-3 col-lg-3">
                  <CardInfo sessionName="Receita" iconName="bar_chart" info="Ver Extrato" link="financeiro" colorIcon="primary" />
                </v-col>-->

                <v-col class="col-10 col-sm-6 col-md-3 col-lg-3">
                  <CardInfo
                    sessionName="Avaliação"
                    iconName="star"
                    :info="average_rating"
                    colorIcon="#ED8A19"
                  />
                </v-col>
              </v-row>
            </v-container>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-footer class="pa-0">
      <v-row class="justify-center ma-0">
        <v-col class="primary py-3 text-center white--text col-12" style="font-size: 12px">
          <strong>RESPONSÁVEL TÉCNICO</strong> Inês Mata CRP/03: 9904. OPP: CP 23204
        </v-col>
      </v-row>
    </v-footer>
  </v-app>
</template>

<script>
import http from '@/services/httpClient';
import moment from 'moment';
import HelloWorld from '../../components/HelloWorld';
import CardInfo from '../../components/CardInfo';
import { getConsultationsNow } from '../../services/psychologists';

export default {
  components: {
    HelloWorld,
    CardInfo,
    moment,
  },

  data: () => ({
    cod: '',
    consultation: '',
    qtd_consultation_now: '-',
    total_patients: 0,
    average_rating: '0/5',
    isLoading: true,
    isConsultation: Boolean,
  }),

  async created() {
    await this.getCod();
    await this.getConsultations();
    await this.getConsultationsNow();
    await this.getTotalPatients();
    this.getAverage();
  },

  methods: {
    getCod() {
      this.cod = localStorage.getItem('user-id');
    },
    async getConsultations() {
      const date = moment().format('YYYY-MM-DD HH:mm');
      try {
        const { data, status } = await http.get(
          `/psychologists/${this.cod}/appointments/`,
          {
            params: {
              after_date_time: date,
              limit: '9',
            },
            headers: {
              Authorization: `Token ${localStorage.getItem('user-token')}`,
            },
          },
        );
        if (status == 200) {
          if (data.length != 0) {
            this.consultation = data;
            this.isConsultation = true;
          } else {
            this.isConsultation = false;
          }
        }
        // console.log(this.consultation);
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
    async getConsultationsNow() {
      try {
        const result = await getConsultationsNow(
          this.cod,
          new Date().toISOString().substr(0, 10),
        );
        const { length } = result.data;
        this.qtd_consultation_now = `${length} consultas hoje`;
      } catch (error) {
        console.log(error);
      }
    },
    async getTotalPatients() {
      try {
        const { data, status } = await http.get(
          `/psychologists/${this.cod}/patients/`,
          {
            headers: {
              Authorization: `Token ${localStorage.getItem('user-token')}`,
            },
          },
        );

        if (status == 200) {
          this.total_patients = data.length;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getAverage() {
      try {
        const { data, status } = await http.get(
          `/psychologists/${this.cod}/assessments/average/`,
          {
            headers: {
              Authorization: `Token ${localStorage.getItem('user-token')}`,
            },
          },
        );

        if (status == 200) {
          this.average_rating = `${data.average_rating}/5`;
        }
      } catch (error) {
        console.log(error);
      }
    },
    moment,
  },
};
</script>

<style lang="scss" scoped>
h2 {
  color: var(--v-primary-base);
}

.block-search {
  background-image: url("../../assets/bg_dashboard.png");
  height: 360px;
  display: block;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
.my-list {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 5px 0;

  p {
    flex: 1;
  }
}
.no-schedule {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background: #02a55333;
  border-radius: 20px;
  border: 1px dashed #02a554;
}
</style>
